// extracted by mini-css-extract-plugin
module.exports = {"wrapperContainer":"report-builder_wrapperContainer__2bpG5","title":"report-builder_title__3kBaa"};